import React, { useEffect, useRef } from "react";

export default function Footer() {
  const container = useRef();

  useEffect(() => {
    // Prevent duplicate script injection
    if (container.current.querySelector('script')) return;

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      "symbols": [
        { "proName": "FOREXCOM:SPX500", "title": "S&P 500" },
        { "proName": "FOREXCOM:NSXUSD", "title": "US 100" },
        { "proName": "FX_IDC:EURUSD", "title": "EUR/USD" },
        { "proName": "BITSTAMP:BTCUSD", "title": "Bitcoin" },
        { "proName": "OANDA:XAUUSD", "title": "Gold" },
        { "proName": "FX_IDC:GBPUSD", "title": "GBP/USD" }
      ],
      "showSymbolLogo": true,
      "colorTheme": "dark",
      "isTransparent": true,
      "displayMode": "adaptive",
      "locale": "en"
    });
    container.current.appendChild(script);
  }, []);

  return (
    <footer style={styles.footerContainer} ref={container}>
      <div className="tradingview-widget-container__widget"></div>
    </footer>
  );
}

const styles = {
  footerContainer: {
    width: "100%", // Fix: Use 100% to stay within the main content div
    height: "46px",
    background: "transparent", // Matches Login Page background
    backdropFilter: "blur(12px)",
    borderTop: "1px solid rgba(255, 255, 255, 0.05)",
    overflow: "hidden",
    zIndex: 10 // Stays below the sidebar z-index
  }
};